import React from 'react';
import { Star, Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Section, CountdownTimer, CTAButton } from './Shared';
export const Pricing = () => {
  return <Section id="pricing" className="bg-brand-surfaceLight/30 rounded-3xl my-12" data-id="element-299">
      <div className="text-center mb-10" data-id="element-300">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-gold mb-6" data-id="element-301">
          ⏰ EL PRECIO CIERRA EN:
        </h2>
        <CountdownTimer data-id="element-302" />
        <p className="mt-4 text-red-400 font-medium" data-id="element-303">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </p>
        <p className="mt-2 text-brand-gold/80 text-sm" data-id="element-304">
          🔴 Quedan pocos cupos al precio de lanzamiento
        </p>

        <div className="max-w-md mx-auto mt-4" data-id="element-305">
          <div className="w-full bg-white rounded-full h-2.5 border border-brand-pink/30 overflow-hidden shadow-inner" data-id="element-306">
            <div className="bg-brand-green h-2.5 rounded-full" style={{
            width: '68%'
          }} data-id="element-307"></div>
          </div>
          <p className="text-xs text-brand-text/60 mt-2" data-id="element-308">
            68% de cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>

      <div className="max-w-md mx-auto mb-12" data-id="element-309"></div>

      <h3 className="text-3xl font-serif font-bold text-center mb-10" data-id="element-310">
        ELEGÍ TU MEGAPACK
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-311">
        {/* Basic Tier */}
        <div className="glass-panel rounded-3xl p-8 flex flex-col border-brand-pink/30 hover:border-brand-gold/30 transition-colors bg-white/60" data-id="element-312">
          <div className="mb-6" data-id="element-313">
            <h4 className="text-2xl font-serif font-bold mb-2 flex items-center" data-id="element-314">
              📘 MEGAPACK CÓDIGO DE ABUNDANCIA
            </h4>
            <p className="text-brand-gold font-medium" data-id="element-315">
              6 Tomos + 2 Bonus · 180 días de transformación
            </p>
          </div>

          <div className="bg-brand-surfaceLight/50 p-4 rounded-xl mb-6 text-sm text-brand-text/80 border border-brand-pink/20" data-id="element-316">
            <span className="font-bold text-[#D4AF37]" data-id="element-317">Ideal para:</span> Quien
            quiere transformar su realidad financiera en 180 días
          </div>

          <div className="mb-8" data-id="element-318">
            <div className="text-brand-text/50 line-through text-xl mb-1" data-id="element-319">
              $47.000
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-320">
              $19.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-321">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-322">
            <CTAButton fullWidth className="text-base py-4 bg-white text-brand-text border border-brand-gold/30 hover:bg-brand-surfaceLight/80" href="https://www.lumenakasha.com/cart/46699505975485:1" data-id="element-323">
              → QUIERO MI MEGAPACK AHORA
            </CTAButton>
          </div>
        </div>

        {/* Premium Tier */}
        <div className="glass-panel rounded-3xl p-8 flex flex-col border-brand-gold relative transform lg:-translate-y-4 shadow-[0_10px_40px_rgba(212,175,55,0.15)] bg-white/80" data-id="element-324">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-white font-bold px-4 py-1 rounded-full text-sm flex items-center shadow-lg whitespace-nowrap" data-id="element-325">
            <Star className="w-4 h-4 mr-1 fill-current" data-id="element-326" /> MÁS POPULAR
          </div>

          <div className="mb-6 mt-2" data-id="element-327">
            <h4 className="text-2xl font-serif font-bold mb-2 flex items-center text-brand-text" data-id="element-328">
              🏆 MEGAPACK + INSTANTE ABUNDANTE
            </h4>
            <p className="text-brand-gold/80 font-medium" data-id="element-329">
              6 Tomos + 2 Bonus + Agenda 90 días
            </p>
          </div>

          <div className="bg-brand-gold/10 p-4 rounded-xl mb-6 text-sm text-brand-text/90 border border-brand-gold/20" data-id="element-330">
            <span className="font-bold text-brand-gold" data-id="element-331">Ideal para:</span> Quien
            quiere resultados desde el primer día sin leer todo primero
          </div>

          <div className="mb-8" data-id="element-332">
            <div className="text-brand-text/50 line-through text-xl mb-1" data-id="element-333">
              $65.000
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-334">
              $27.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-335">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-336">
            <CTAButton fullWidth className="text-lg py-5 animate-pulse-slow" href="https://www.lumenakasha.com/cart/46699573543101:1" data-id="element-337">
              → QUIERO EL MEGAPACK COMPLETO
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-6 mt-12 text-sm text-brand-muted flex-row items-start justify-center" data-id="element-338">
        <div className="flex items-center" data-id="element-339">
          <Lock className="w-4 h-4 mr-2" data-id="element-340" /> Pago 100% seguro
        </div>
        <div className="flex items-center" data-id="element-341">
          <Zap className="w-4 h-4 mr-2" data-id="element-342" /> Acceso en 5 minutos
        </div>
        <div className="flex items-center" data-id="element-343">
          <Shield className="w-4 h-4 mr-2" data-id="element-344" /> Garantía 7 días
        </div>
        <div className="flex items-center" data-id="element-345">
          <CreditCard className="w-4 h-4 mr-2" data-id="element-346" /> Mercado Pago | Tarjeta |
          Transferencia
        </div>
      </div>
    </Section>;
};